module.exports = __webpack_public_path__ + "static/media/gyro.8d389260.png";